const SoundWaves = ({ playing = true, bars = 5, className = "" }) => {
  return (
    <div className={`flex items-end gap-1 h-8 ${className}`} aria-hidden="true">
      {Array.from({ length: bars }).map((_, i) => (
        <span
          key={i}
          className={`w-1.5 rounded-full ${playing ? "sound-bar" : ""}`}
          style={{
            height: "100%",
            background: "linear-gradient(180deg, #FF6B35 0%, #E91E8C 55%, #6C3FC4 100%)",
            animationDelay: `${i * 0.12}s`,
            transform: playing ? undefined : "scaleY(0.3)",
          }}
        />
      ))}
    </div>
  );
};

export default SoundWaves;
